module.exports = __webpack_public_path__ + "img/contact.07727b6c.png";